<template>
  <div>
    <Loading
      class="py-15 px-5"
      v-if="$store.state.calendar.availableHours.loading"
      :message="$t('calendar.loading')"
    />
    <div
      v-else-if="$store.state.calendar.availableHours.list.length"
      class="group-grid text-center scroll-schedule-availability"
    >
      <div v-for="(dayGroup, index) in groupedHours" :key="`day-${index}`">
        <div class="d-flex items-center mb-2" style="gap: 10px;">
          <Icon
            :width="18"
            :height="18"
            :color="'rgba(0,0,0,.54)'"
            :icon="'calendar-cursor'"
          />
          {{ dayGroup.date }}
        </div>
        <div class="grid">
          <v-chip
            class="pointer"
            v-for="hour in dayGroup.hours"
            :key="`${hour.hour}-${index}`"
            @click="select(hour)"
            outlined
          >
            <span style="font-size: 15px;">
              {{ $ocularMoment.timeZoneDate(hour.hour).format('HH:mm') }}
            </span>
          </v-chip>
        </div>
      </div>
    </div>
    <div
      v-else
      class="py-15 px-5"
    >
      <Empty
        icon="calendar"
        :title="$t('calendar.availableDay')"
        :description="$t('calendar.availableHours')"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

require('@/plugins/OcularMoment')

@Component({
  components: {
    Loading: () => import(/* webpackPrefetch: true */ '@/components/Loading.vue'),
    Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    selectedDay: {
      required: true,
      default: null
    }
  }
})
export default class Detail extends Vue {
  data () {
    return {
      availableHours: {
        loading: false,
        list: [],
        date: null,
        selected: null
      }
    }
  }

  mounted () {
    this.ocGoogleAnalyticsInit()
  }

  select (availableHour) {
    this.$emit('select', availableHour)
  }

  async getHours () {
    this.$store.state.calendar.availableHours.loading = true
    this.$store.state.calendar.availableHours.list = []

    const params = {
      date: this.selectedDay,
      timeZone: this.$widget.getDevice().timeZone
    }

    if (this.$store.state.storage.category) {
      params.categoryId = this.$store.state.storage.category.id
    }

    this.$calendar.getAvailableHours(params)
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('available.hours')
  }

  get groupedHours () {
    const grouped = {}
    this.$store.state.calendar.availableHours.list.forEach(hour => {
      const date = this.$ocularMoment.timeZoneDate(hour.hour).format('YYYY-MM-DD')
      if (!grouped[date]) {
        grouped[date] = {
          date: this.$ocularMoment.timeZoneDate(hour.hour).format('LL'),
          hours: []
        }
      }
      grouped[date].hours.push(hour)
    })
    return Object.values(grouped)
  }
}
</script>

<style scoped>
.group-grid {
  display: grid;
  gap: 25px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  justify-items: center;
  align-items: center;
}

.scroll-schedule-availability {
  max-height: 60vh;
  width: 100%;
  overflow-y: auto;
  scrollbar-width: thin !important;
}
</style>